<template>
    <div v-if="taskId&&workFlowEntity.currTaskSidNum!=1">
        <!-- 审批提交按钮 -->
        <div class="btn">
            <van-button size="small" v-if="showSaveButton" type="primary" @click="saveFormData">保存</van-button>
            <van-button v-if="workFlowEntity.currTaskSidNum>1" size="small" @click="openDialog('disagreeReject')">拒绝</van-button>
            <van-button size="small" type="info" @click="openDialog('agreeSubmit')">通过</van-button>
        </div>
        <!-- 审批意见提交按钮 -->
        <van-popup v-model="show" position="bottom" round class="dialog">
            <p>审批意见</p>
            <van-radio-group v-model="selectOperationValue" class="radio">
                <span>审批意见</span>
                <van-radio name="agreeSubmit">通过</van-radio>
                <van-radio v-if="workFlowEntity.currTaskSidNum>1" name="disagreeReject">拒绝</van-radio>
            </van-radio-group>
            <!-- <van-radio-group v-if="selectOperationValue=='disagreeReject'&&!workFlowEntity.secondNode" v-model="reFundSid" class="radio">
                <span>驳回节点</span>
                <van-radio v-for="item in reFundList" :name="item.userTaskId" :key="item.userTaskId">
                    <div v-for="(user,index) in item.userList" :key="index">
                        <span>{{user.userName}}</span>
                        <span style="margin-left:10px;">{{user.option}}</span>
                    </div>
                </van-radio>
            </van-radio-group> -->
            <van-field v-model="comment" label="意见详情" label-width="80px" placeholder="请输入意见（注意，意见内容请勿包含&字符）" class="input"></van-field>
            <van-button size="small" type="info" @click="submit" class="submit">提交</van-button>
        </van-popup>
    </div>
</template>
<script>
export default {
    props:{
        workFlowGuid: String,
        workFlowFormKey: String,
        showSaveButton:Boolean,
        workFlowFormVar:{
            type:Object,
            default(){
                return {}
            }
        },
        businessGuid:String,
    },
    watch:{
        workFlowGuid:{
            deep:true,
            immediate:true,
            handler(val,old){
                if(JSON.stringify(val)!=JSON.stringify(old)){
                    this.ACT_getWorkFlow()
                }
            }
        },
        workFlowFormVar:{
            deep:true,
            immediate:true,
            handler(val,old){
                if(JSON.stringify(val)!=JSON.stringify(old)){
                    this.ACT_getWorkFlow()
                }
            }
        }
    },
    data(){
        return {
            //意见弹窗显示隐藏
            show: false,
            //审批意见
            selectOperationValue: "",
            //意见详情
            comment: "",
            //当前任务ID
            taskId:'',
            workFlowEntity:{},
            taskEventData:{},
            reFundSid:'',
            reFundList: [],
        }
    },
    methods: {
        saveFormData(){
            this.$emit('saveFormData')
        },
        //获取工作流
        async ACT_getWorkFlow() {
            if(!this.workFlowGuid||!this.workFlowFormKey){
                this.loading=false;
                return;
            }

            await this.$http
            .get("/api/activiti/v0.1/workflow/getWorkFlow",{
            params:{
                businessKey:this.workFlowGuid,
                formKey:this.workFlowFormKey,
                formVar:JSON.stringify(this.workFlowFormVar),
            }
            })
            .then(async (res) => {
            var js = res.data;
            if (js.errcode == 0) {
                this.workFlowEntity = js.data;
                let hidTimeRecord = []
                this.workFlowEntity.userListYes = this.workFlowEntity.userListYes.map(item=>{
                let arr = new Array();
                for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
                    arr.push(this.workFlowEntity.userListYes[i].userTaskId);
                }
                if(this.hiddenNodeApproveRecord&&this.hiddenNodeApproveRecord==item.userTitle){
                    hidTimeRecord.push(...item.userList.map(item=>{
                    return item.userTaskEndtime
                    }))
                }
                let sidIndex = arr.indexOf(item.userTaskId);
                let currIndex = arr.indexOf(this.workFlowEntity.currUserTaskSid);
                if(sidIndex - currIndex == 1&&((!item.userList)||item.userList.length<1)){
                    item.curNodeEditColor = 'red'
                }
                item.showUserList = item.userList.slice(0,2)
                return item
                })
                console.log("让我看看");
                console.log(this.workFlowEntity);
                this.historyInfo = this.workFlowEntity.historyInfo.sort(()=>{return -1})
                for(let i=0;i<this.historyInfo.length;i++){
                for(let j=0;j<this.historyInfo.length -1-i;j++){
                    if(Date.parse(this.historyInfo[j].userTaskEndtime) <Date.parse(this.historyInfo[j+1].userTaskEndtime)){
                    [this.historyInfo[j],this.historyInfo[j+1]]=[this.historyInfo[j+1],this.historyInfo[j]]
                }
                }
                }
                if(this.hiddenNodeApproveRecord){
                this.historyInfo = this.historyInfo.filter(item=>{
                    if(hidTimeRecord.indexOf(item.userTaskEndtime)>-1){
                    return false
                    }
                    return true
                })
                }
                console.log(this.historyInfo,666);
                this.oguName = this.workFlowEntity.userInfo.oguName;
                this.orgUserGuid = this.workFlowEntity.userInfo.orgUserGuid;
                this.nowDate = this.workFlowEntity.nowDate;
                this.taskId = this.workFlowEntity.taskId;
                this.currTaskSidNum = this.workFlowEntity.currTaskSidNum;
                this.userListYesNum = this.workFlowEntity.userListYesNum;
                this.secondNode = this.workFlowEntity.secondNode;
                this.reFundFastSid = this.workFlowEntity.reFundSid;
                if(js.data.workFlowStatus==0){
                this.confirmTxt="提交";
                }
                if(!js.data.beCurrUser && js.data.workFlowStatus==0) {
                    this.$emit('workFlowStatus', -1); // 把工作流状态传给父组件
                } else {
                    this.$emit('workFlowStatus', js.data.workFlowStatus); // 把工作流状态传给父组件
                }

                this.$emit('workFlowNode',js.data.userListYes,js.data.currUserTaskSid,js.data.uGuid,js.data.workFlowStatus);
                let allApprovalUserIds = []
                let allApprovalUserNos = []
                js.data.userListYes.forEach((item,index)=>{
                    if(index!=0){
                    item.userList.forEach(item1=>{
                        allApprovalUserIds.push(item1.userName)
                        allApprovalUserNos.push(item1.orgUserGuid)
                    })
                    }
                    if(js.data.currTaskSidNum==item.nodeNum&&js.data.userListYes.length>(index+1)){
                    let user = js.data.userListYes[index+1]
                    this.taskEventData.afterTaskUser = user.userList.map(item=>{
                        return item.orgUserGuid
                    }).join(',')
                    this.taskEventData.afterTaskTitle = user.userTitle
                    }
                })
                this.taskEventData.allApprovalUserIds=allApprovalUserIds
                this.taskEventData.allApprovalUserNos=allApprovalUserNos
                this.taskEventData.workFlowStatus = js.data.workFlowStatus
                let curName = this.Cookie.get('oguName')
                let curTask = js.data.userListYes.find((item,index)=>{
                    return item.nodeNum == js.data.currTaskSidNum
                })
                console.log(curTask,"看看")
                console.log(js.data,"测试数据")
                this.taskEventData.curTaskTitle = (curTask?curTask.userTitle:'')
                this.taskEventData.curTaskIsFirst = js.data.currUserTaskSid == js.data.startUserTaskSid
                this.taskEventData.firstTaskUser=js.data.userListYes[0].userList[0].userName == curName&&this.taskEventData.curTaskIsFirst
                this.taskEventData.firstUser = js.data.userListYes[0].userList[0].orgUserGuid
                this.taskEventData.firstUserName = js.data.userListYes[0].userList[0].userName
                if(js.data.userListYes[js.data.userListYesNum-1].userList.length > 0){
                this.taskEventData.lastTaskUser = js.data.userListYes[js.data.userListYesNum-1].userList[0].userName == curName?true:false
                }else {
                this.taskEventData.lastTaskUser = false;
                }
                console.log(this.workFlowEntity)
                console.log(js.data,"测试数据")
                this.taskEventData.isTask = js.data.taskId?true:false
                console.log(this.taskEventData,"看看数据")
                this.taskEvent()
                this.loading = false;
                this.reFundList = [];
                for (let i = 0; i < this.workFlowEntity.userListYes.length; i++) {
                    if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[i].userTaskId){
                        break;
                    }else{
                        let users = this.workFlowEntity.userListYes[i]
                        users.userList = users.userList.map(item=>{
                            if(i==0){
                                item.option = '起草'
                            }else{
                                item.option = item.userComment[0].userOpinion.split('&')[0]
                            }
                            return item
                        })
                        this.reFundList.push(users);
                    }
                }
                this.reFundSid = this.workFlowEntity.userListYes[0].userTaskId
                console.log(this.reFundList)
            } else if (js.errcode == 102) {
                //没有此流程就部署流程
                if(this.deployWorkFlow&&this.hasBS!=this.workFlowGuid){
                // this.hasBS = this.workFlowGuid
                await this.ACT_Deploy();
                }

            } else {
                this.loading = false;
                this.$message({
                showClose: true,
                message: js.errmsg,
                type: "error",
                });
            }
            });
        },
        //打开审批弹窗
        openDialog(type){
            this.$set(this,'selectOperationValue',type)
            if(type=='agreeSubmit'&&this.$listeners.callWorkFlowForm&&this.showSaveButton){
                this.$emit('callWorkFlowForm',(val)=>{
                if(val){
                    return;
                }else{
                    this.show = true;
                }
                });
            }else{
                this.show = true;
            }
        },
        taskEvent(){
            if(!this.taskEventData.hasOwnProperty('firstUser')){
                return
            }
            this.taskEventData.showSaveButton=this.showSaveButtonVal
            this.$emit('taskEvent',this.taskEventData)
        },
        //提交审批数据
        submit(){
            this.ACT_confirm()
        },
        //确认送签
        ACT_confirm(comment) {
            if(comment){
                this.comment = comment
            }
            if (!this.taskId) {
                this.$message({
                showClose: true,
                message: "您没有此任务，不能操作。",
                type: "error",
                });
                return;
            }

            //驳回操作判断
            if (this.selectOperationValue == "disagreeReject") {
                this.confirmFastReject()
                return;
            }
            //送签前调用父窗口进行业务校验
            // let callWorkFlowFormResult={
            //   errcode:0,
            //   errmsg:''
            // };
            if(this.$listeners.callWorkFlowForm&&this.showSaveButton){
                this.$emit('callWorkFlowForm',(val)=>{
                if(val){
                    this.show = false
                    return;
                }else{
                    this.tjsq()
                }
                });
            }else{
                this.tjsq()
            }
        },

        tjsq(){
            this.loading = true;
            //送签操作
            this.$http
                .post(
                "/api/activiti/v0.1/workflow/operationSend",
                this.$qs.stringify({
                    businessKey: this.workFlowGuid,
                    formKey:this.workFlowFormKey,
                    taskId: this.taskId,
                    selectOperation: this.selectOperationValue,
                    comment: this.comment,
                    formVar:JSON.stringify(this.workFlowFormVar),
                    formData:JSON.stringify(this.workFlowFormData),
                    jsonDatas:this.taskSubject,
                    notSendMsg:this.notSendMsg,
                    sendFsApprove:this.sendFsApprove
                })
                )
                .then(async(res) => {

                var js = res.data;
                if (js.errcode == 0||(!js.errmsg)) {
                    this.ACT_getWorkFlow();
                    let workFlowstatus=js.data.workFlowStatus;
                    //送完后的操作
                    this.$emit('sendWorkFlow',workFlowstatus); // 直接修改父组件的属性
                    //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
                    this.showSaveButtonVal = false
                    this.loading = false;
                    
                } else {
                    this.loading = false;
                    this.$message({
                    showClose: true,
                    message: js.errmsg,
                    type: "error",
                    });
                }
                }).catch(err=>{
                console.log('审批报错.....',err);
                if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[this.workFlowEntity.userListYes.length-1].userTaskId){
                    //送完后的操作
                    this.$emit('sendWorkFlow',1); // 直接修改父组件的属性
                    //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
                    this.showSaveButtonVal = false
                    this.loading = false;
                }
                });
                setTimeout(()=>{
                console.log('审批超时......');
                if(this.loading){
                    if(this.workFlowEntity.currUserTaskSid==this.workFlowEntity.userListYes[this.workFlowEntity.userListYes.length-1].userTaskId){
                    //送完后的操作
                    this.$emit('sendWorkFlow',1); // 直接修改父组件的属性
                    //解决接口报404后不刷新浏览器bug 导致还存在保存按钮
                    this.showSaveButtonVal = false
                    this.loading = false;
                    }
                }
            },2500)
        },
        //确认驳回操作
        confirmFastReject() {
            console.log("驳回操作")
            this.$http
                .post(
                "/api/activiti/v0.1/workflow/operationReject",
                this.$qs.stringify({
                    businessKey: this.workFlowGuid,
                    taskId: this.taskId,
                    toactusertasksid: this.reFundSid,
                    comment: this.comment,
                    sendFsApprove:this.sendFsApprove,
                })
                )
                .then(async (res) => {
                var js = res.data;
                if (js.errcode == 0) {
                    this.showRefund = false;
                    
                    let workFlowstatus=js.data.workFlowStatus;
                    //驳回后的操作
                    this.$emit('sendWorkFlow',workFlowstatus, '驳回'); // 直接修改父组件的属性
                    this.$emit('workflowReject',workFlowstatus,"驳回废弃");
                    this.showSaveButtonVal = false
                    this.loading = false;
                    this.ACT_getWorkFlow();
                } else {
                    this.loading = false;
                    this.$message({
                    showClose: true,
                    message: js.errmsg,
                    type: "error",
                    });
                }


                }).catch(err=>{
                this.showRefund = false;
                this.ACT_getWorkFlow();
                this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
                this.$emit('workflowReject',0);
                this.loading = false;
                });
                //解决驳回后端处理后 但不返回数据导致前端无反应bug
                setTimeout(()=>{
                // if(this.showRefund){
                    this.showRefund = false;
                    this.ACT_getWorkFlow();
                    this.$emit('sendWorkFlow',0); // 直接修改父组件的属性
                    this.$emit('workflowReject',0);
                    this.loading = false;
                // }
                },2500)
        },
    }
}
</script>
<style lang="less" scoped>
    .btn{
        position: fixed;
        bottom: 0px;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 80px;
        line-height: 70px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background: #fff;
        button{
            width: 100px;
            margin: 0 10px;
        }
    }
    .dialog{
        .radio{
            display: flex;
            padding: 0 16px;
            font-size: 12px;
            span{
                text-align: left;
                width: 80px;
            }
            .van-radio{
                margin-right: 10px;
                /deep/.van-radio__icon{
                    font-size: 16px;
                }
                /deep/.van-radio__label{
                    margin-left: 5px;
                }
            }
        }
        .input{
            font-size: 12px;
        }
        /deep/.van-field__label{
            font-size: 12px !important;
            margin-right: 0;
        }
        .submit{
            width: 80%;
            margin: 20px auto;
        }
    }
</style>